export const getPitch = (state) => state.pitch;

export const getPitchId = (state) => getPitch(state).ID;

export const getPitchVideos = (state) => getPitch(state).videos;

export const getPitchVideosMerged = (state) => getPitch(state).videos_merged || {};

export const getPitchVideosByPoolName = (state, poolName) => getPitchVideosMerged(state)[poolName];
